import { Container } from 'pixi.js';
import { Screen } from "./Screen";

/**
 */
export class ScreenContainer extends Container {
  /**
   */
  public children: Screen[];
}
